import { css } from 'styled-components';

const OrdersRedesignTileStyle = css`
  &.orders-carousel-mobile-view {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }
  &.orders-carousel-tablet-desktop-view {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
    }
  }
  &.no-order-tile {
    width: 100%;
    .no-order-tileWrapper {
      padding: ${(props) =>
        `${props.theme.spacing.ELEM_SPACING.LRG} ${props.theme.spacing.ELEM_SPACING.MED}`};
    }
  }
  .order-detail-link-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .tileWrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    border-bottom: 0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  &.orders-redesign-carousel-new {
    width: 100%;
    flex-direction: column;
    .slick-track {
      display: inline-flex;
    }
    .slick-slider {
      padding: 0;
    }
    .slick-dots {
      justify-content: flex-start;
      position: relative;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
    }
    .slick-dots ul {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    .slick-dots li {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0 0;
      width: 40px;
      height: 4px;
    }
    .slick-dots li button {
      width: 40px;
      height: 4px;
    }
    .slick-dots li button:before {
      width: 40px;
      height: 4px;
      border-radius: 0;
      background: #b0b0b0;
    }
    .slick-dots li.slick-active button:before {
      background: ${(props) => props.theme.colorPalette.blue[900]};
    }
  }
`;
export default OrdersRedesignTileStyle;
